import axios from '@/libs/api.request.js';

const advert = {

    // 获取广告列表
    getAdvertList: (data) => {
        // data{AdvertTagType:2 会员中心首页}
        return axios.get({
            url: '/wap/Advert/advertlist?' + axios.parseParams(data)
        })
    }
};

export default advert;


// WEBPACK FOOTER //
// ./src/api/api-advert.js